import React, { useEffect, useState } from 'react';
import { change, Field } from 'redux-form';
import { FormElems } from '../../..';
import { BUSINESS_SECTION_TYPE_MLE, MAXIMUM_VALUE, MINIMUM_VALUE, MLE_CREATE_FORM_NAME, getMleFields, PIN_ERROR, PREFIX_KYCURLS, mleFields } from "./contants";
import { connect } from 'react-redux';
import { capitalizeFirstLetterOfEachWord, nameValueOptions } from '../../../../utils/helperMethods';
import { bindActionCreators } from 'redux';
import { allowedExtensions, allowedImgExtensions, checkPiiData, defaultOption, fetchBasicDataBusinessDetails, fetchFieldValue, fetchKycDocsS3Details, fetchPiiData, fetchPinCodeDetails, FIELD_TYPES, getFormattedDateusingUrl, getTimeStampFromUrl, handlePiiUpload, handleVerifyPiiAccount, handleViewClick, isApproved, isGstVerifyDisable, isPanVerifyDisable, redClassRemarksCond, removeDuplicates, setInitialPiiData, showCheckerRemark, VERIFIED, verifyAccountDetails, verifyGstDetails, verifyPanDetails } from '../mle.utils';
import { ERROR_FETCH, FILE_MSG, GST, IMAGE_MSG, KYC_FILES, ONBOARDING_TYPE, PAN } from '../mle.constants';
import { toast } from 'react-toastify';
import './businessTab.scss';
import Address from 'components/Address';
import { PanOcr } from 'components/PanOcr';
import VerifyButton from 'components/VerifyButton/VerifyButton';
import MyTooltip from './MyTooltip';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { ERROR_MESSAGES } from 'utils/constants/toastMessages';
import TitleComponent from 'components/TitleComponent';
import SwitchInput from 'components/InputField/switchInput';

const fetchDataFromReducerObject = (merchantLegalEntityData) => {
    let constitutionTypes = [];
    let turnOverData = {};
    if (merchantLegalEntityData?.basicFormData?.basicSectionData) {
        let {basicSectionData} = merchantLegalEntityData.basicFormData;
        constitutionTypes = basicSectionData.constitutionTypes || [];
        turnOverData = basicSectionData.turnOverData || {};
    }

    return {
        constitutionTypes,
        turnOverData
    }
}

const MleInformation = ({
    isViewMode,
    isEditMode,
    merchantLegalEntityData,
    actions,
    mutateFormData,
    setKycDocsList,
    setIsUploading,
    setSelectedDocument,
    setIsPiiVerified,
    isPiiVerified,
    checkerRemarks,
    setIntentId,
    intentId,
    setKycListUpdated,
    infoMsgs,
    entityId,
    isReEditFlow,
    setIsResetDocs,
    createdAt,
    setDocTimeStamp,
    isMakerFlow,
    setCurrentGstValue,
    eventType,
    isUpdate
}) => {
    
    const {constitutionTypes, turnOverData} = fetchDataFromReducerObject(merchantLegalEntityData);
    const [basicFormDataList, setBasicFormDataList] = useState({
        constitutionTypes,
        turnOverData
    });
    const history = useHistory();
    const [pinCodeDetails, setPinCodeDetails] = useState([]);
    const [piiData, setPiiData] = useState({});
    const [retryCount, setRetryCount] = useState(0);
    const [currentMleFields, setCurrentMleFields] = useState(mleFields);
    const [optionalFields, setOptionalFields] = useState([]);

    useEffect(() => {
        if (retryCount > 1) {
            toast.error(ERROR_MESSAGES.OFFLINE_MSG)
            history.push('/mle-onboarding');
        } else if (retryCount > 0) {
            setBasicFormData();
        }
    }, [retryCount]);
    
    useEffect(() => {
        if (mutateFormData?.values?.[currentMleFields.businessType.name]) {
            handleChangeBusinessType(mutateFormData.values[currentMleFields.businessType.name], 'edit');
        }
    }, [mutateFormData?.initial?.[mleFields.businessType.name]]);

    useEffect(() => {
        const businessType = mutateFormData?.values?.businessType;
        if (businessType && optionalFields?.length > 0) {
            setCurrentMleFields(getMleFields(businessType, optionalFields));
        }
    }, [mutateFormData?.values?.businessType, optionalFields]);

    const handleChangeBusinessType = async (businessType, event = undefined, sad) => {
        setIsUploading(true);
        try {
            let payload = {
                sectionType: BUSINESS_SECTION_TYPE_MLE,
                fieldType: FIELD_TYPES.constitutionType,
                fieldValue: businessType
            }
            let kycDocs = await fetchKycDocsS3Details(payload);
            
            let mandatoryDocs = kycDocs?.basicSectionData?.constitutionTypesDocuments?.mandatoryDocs || [];
            let partiallyMandatoryDocs = kycDocs?.basicSectionData?.constitutionTypesDocuments?.partiallyMandatoryDocs || [];
            let optionalFields = kycDocs?.basicSectionData?.optionalFields || [];
            setOptionalFields(optionalFields);
            setKycDocsList({ mandatoryDocs, partiallyMandatoryDocs });
            actions.change(MLE_CREATE_FORM_NAME, 'mandatoryDocs', mandatoryDocs);
            actions.change(MLE_CREATE_FORM_NAME, 'partiallyMandatoryDocs', partiallyMandatoryDocs);
            actions.change(MLE_CREATE_FORM_NAME, 'optionalFields', optionalFields);
            if (!event) {
                if (mutateFormData?.initial?.[mleFields.businessType.name] === businessType && (!!isEditMode || !!isReEditFlow || !!isMakerFlow)) {
                    setIsResetDocs(true);
                } else {
                    setIsResetDocs(false);
                }
                actions.change(MLE_CREATE_FORM_NAME, PREFIX_KYCURLS, null);
                setKycListUpdated((prev) => prev+1)
            }
        } catch(e) {
            toast.error(ERROR_FETCH);
        }
        setIsUploading(false);
    }
    const setBasicFormData = async () => {
        try {
            let sectionType = BUSINESS_SECTION_TYPE_MLE;
            let entityCode = BUSINESS_SECTION_TYPE_MLE;
            const data = await fetchBasicDataBusinessDetails({
                sectionType,
                entityCode
            });
            
            if (data?.statusCode === apiStatusCodes.SUCCESS2) {
                setBasicFormDataList({
                    constitutionTypes: data?.basicSectionData?.constitutionTypes,
                    turnOverData: data?.basicSectionData?.turnOverData
                })
            } else {
                setRetryCount((count) => count+1);
            }
        }
        catch(e) {
            console.log("setBasicFormDatae", e);
        }
    }

    useEffect(() => {
        if (basicFormDataList?.constitutionTypes?.length === 0) {
            setBasicFormData()
        }
    }, [basicFormDataList.constitutionTypes]);

    useEffect(() => {
        let gstUploaded = piiData[GST];
        
        if (gstUploaded?.documentDetails) {
            let documentDetails = gstUploaded?.documentDetails;
            
            if (documentDetails?.gstNumber?.value?.toString()?.length < 16)
                actions.change(MLE_CREATE_FORM_NAME, currentMleFields.gst.name, documentDetails?.gstNumber?.value);
            else {
                actions.change(MLE_CREATE_FORM_NAME, currentMleFields.gst.name, '');
            }
        }
    }, [piiData[GST]]);

    useEffect(()=>{
            setPiiData(setInitialPiiData({values: mutateFormData.values, fields: getMleFields(mutateFormData?.values?.businessType || '')}));
    },[mutateFormData?.initial?.panDetails?.url, mutateFormData?.initial?.panDetails?.panNumber, mutateFormData?.initial?.gstUploadFile]);

    const handleChangeCategory = (val) => {
        actions.change(MLE_CREATE_FORM_NAME, MAXIMUM_VALUE, turnOverData[val].maximum); 
        actions.change(MLE_CREATE_FORM_NAME, MINIMUM_VALUE, turnOverData[val].minimum);
    }

    const formattedConstitutionData = [...defaultOption, ...basicFormDataList?.constitutionTypes].map((item) => ({
        ...item,
        name: capitalizeFirstLetterOfEachWord(item.name),
    }));

    const handleChangegst = (val) => {
        try {
            setPiiData((data) => {
                let piiCode = data;
                checkPiiData(piiCode, GST, 'gstNumber')
                piiCode[GST].documentDetails.gstNumber.value = val;
                return piiCode;
            });
            setCurrentGstValue(val)
        } catch(e) {
            console.error(e);
        }
    }

    const handleChangeturnOverAmount = (val) => {
        try {
            let mapAmount = {};
            Object.keys(basicFormDataList.turnOverData).map(item => {
                let itemVal = basicFormDataList.turnOverData[item];
                if (itemVal.maximum)
                    mapAmount[itemVal.maximum] = item;
                else 
                    mapAmount['inf'] = item; 
            });
            
            let isUpdated = false;
            Object.keys(mapAmount).map(amt => {
                if (!isUpdated) {
                    if (amt == 'inf' || (!isNaN(amt) && parseInt(amt) >= val)) {
                        isUpdated = true;
                        actions.change(MLE_CREATE_FORM_NAME, 'turnoverCategory', mapAmount[amt]);
                        handleChangeCategory(mapAmount[amt]);
                    }
                }
            })
        } catch(e) {
            toast.error(e.message)
        }
    }

    const panName = fetchFieldValue(mutateFormData.values, currentMleFields.panName.name);
    const legalName = fetchFieldValue(mutateFormData.values, currentMleFields.legalName.name);
    const legalInfoMsg = (panName !== legalName) ? infoMsgs?.[currentMleFields.legalName.name] ?? '' : '';
    const panInfoMsg = (panName !== legalName) ? infoMsgs?.[currentMleFields.panName.name] ?? '' : '';


    return (
        <ul className="form-list">
            {/* Do not delete this comment */}
            {/* <li className='form-section'>
                 <div className="form-field">
                    <SwitchInput
                        alignStartCss={true}
                        label={currentMleFields.source.label}
                        fieldName={currentMleFields.source.name}
                        checkedValue={ONBOARDING_TYPE["axis"]}
                        uncheckedValue={ONBOARDING_TYPE[`other`]}
                        fieldIsDisbale={isViewMode || isApproved(checkerRemarks, currentMleFields.source.name, null, isEditMode)}
                                        />
                </div>
            </li> */}
            <li className="form-section">
                
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.legalName}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.legalName.name}
                    />
                    
                    <Field
                        name={currentMleFields.legalName.name}
                        type={currentMleFields.legalName.type}
                        id={currentMleFields.legalName.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.legalName.label}
                        disabled={isViewMode || isApproved(checkerRemarks, currentMleFields.legalName.name, null, isEditMode)}
                        infoElement={infoMsgs?.[currentMleFields.legalName.name]}
                    />
                </div>
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.brandName}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.brandName.name}
                    />
                    <Field
                        name={currentMleFields.brandName.name}
                        type={currentMleFields.brandName.type}
                        id={currentMleFields.brandName.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.brandName.label}
                        disabled={isViewMode || isApproved(checkerRemarks, currentMleFields.brandName.name, null, isEditMode)}
                    />
                </div>
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.businessType}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.businessType.name}
                    />

                    <Field
                        name={currentMleFields.businessType.name}
                        type={currentMleFields.businessType.type}
                        id={currentMleFields.businessType.name}
                        component={FormElems.Select}
                        labelField="name"
                        valueField="type"
                        data={formattedConstitutionData}
                        onChange={val => handleChangeBusinessType(val)}
                        placeholder={currentMleFields.businessType.label}
                        disabled={
                            isViewMode || isApproved(checkerRemarks, currentMleFields.businessType.name, null, isEditMode)
                        }
                    />
                </div>
                <Address
                    fields={currentMleFields}
                    setIsUploading={setIsUploading}
                    setPinCodeDetails={setPinCodeDetails}
                    actions={actions}
                    formName={MLE_CREATE_FORM_NAME}
                    pinCodeDetails={pinCodeDetails}
                    isViewMode={isViewMode}
                    values={mutateFormData.values}
                    checkerRemarks={checkerRemarks}
                    isEditMode={isEditMode}
                    infoMsgs={infoMsgs}
                    isReEditFlow={isReEditFlow}
                />
                <PanOcr
                    fields={currentMleFields}
                    formName={MLE_CREATE_FORM_NAME}
                    actions={actions}
                    setPiiData={setPiiData}
                    setIsUploading={setIsUploading}
                    piiData={piiData}
                    isViewMode={isViewMode}
                    setSelectedDocument={setSelectedDocument}
                    setIsPiiVerified={setIsPiiVerified}
                    itemCount={1}
                    isPiiVerified={isPiiVerified}
                    values={mutateFormData.values}
                    checkerRemarks={checkerRemarks}
                    intentId={intentId}
                    setIntentId={setIntentId}
                    isEditMode={isEditMode}
                    infoMsgs={infoMsgs}
                    entityId={entityId}
                    isReEditFlow={isReEditFlow}
                    panInfoMsg={panInfoMsg}
                    initialValues={mutateFormData?.initial}
                    createdAt={createdAt}
                    setDocTimeStamp={setDocTimeStamp}
                    checkoutMigrated={merchantLegalEntityData?.formData?.checkoutMigrated}
                />
                <div className="form-field uploadDivContainer">
                    <TitleComponent 
                        field={currentMleFields.gstUpload}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.gstUpload.reqName}
                        customClass="gstUploadLabel"
                        fieldDate={getFormattedDateusingUrl(fetchFieldValue(mutateFormData.values, currentMleFields.gstUpload.reqName), createdAt)}
                    />
                    <div className="gst-upload-parent">
                        <Field
                            handleChange={(name, value) => {
                                if (!value)
                                    actions.change(MLE_CREATE_FORM_NAME, currentMleFields.gstUpload.reqName, null);
                            }}
                            uploadImageAndGetURL={file => {
                                return handlePiiUpload({
                                    file: file,
                                    type: GST,
                                    name: currentMleFields.gstUpload.reqName,
                                    actions: actions,
                                    setPiiData: setPiiData,
                                    setIsPiiVerified: setIsPiiVerified,
                                    setIsUploading: setIsUploading,
                                    formName: MLE_CREATE_FORM_NAME,
                                    intentId: intentId,
                                    isEditMode: isEditMode || isReEditFlow,
                                    entityId: entityId,
                                });
                            }}
                            docUrl={piiData?.[GST]?.s3Path || ''}
                            handleView={docUrl => handleViewClick(docUrl, setIsUploading, setSelectedDocument, setDocTimeStamp, createdAt, merchantLegalEntityData?.formData?.checkoutMigrated)}
                            name={currentMleFields.gstUpload.name}
                            type={currentMleFields.gstUpload.type}
                            id={currentMleFields.gstUpload.name}
                            component={FormElems.UploadElement}
                            wrapperClass
                            // infoElement="Filesize 5mb and file type pdf/image"
                            placeholder={currentMleFields.gstUpload.label}
                            allowedExtensions={allowedExtensions}
                            MaxFileSize={currentMleFields.gstUpload.maxFileSize}
                            accept={currentMleFields.gstUpload.accept}
                            infoElement={`${IMAGE_MSG}${allowedExtensions.join(', ')}`}
                            disabled={
                                isViewMode ||
                                (isApproved(checkerRemarks, currentMleFields.gstUpload.reqName, null, isEditMode) &&
                                    isApproved(checkerRemarks, currentMleFields.gst.name, null, isEditMode))
                            }
                        />
                    </div>
                </div>
                <div className="form-field">
                    <TitleComponent 
                    field={currentMleFields.gst} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode}
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={currentMleFields.gst.name} />
                    <Field
                        name={currentMleFields.gst.name}
                        type={currentMleFields.gst.type}
                        id={currentMleFields.gst.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.gst.label}
                        onChange={handleChangegst}
                        disabled={
                            isViewMode ||
                            !piiData?.[GST]?.s3Url ||
                            isPiiVerified?.[GST]?.verifiedStatus === VERIFIED ||
                            isApproved(checkerRemarks, currentMleFields.gst.name, null, isEditMode)
                        }
                    />
                </div>

                <div className="form-field"></div>
                <VerifyButton
                    field={currentMleFields.verifyGst}
                    isVerified={isPiiVerified?.[GST]?.verifiedStatus === VERIFIED}
                    isDisable={
                        isViewMode ||
                        isGstVerifyDisable(mutateFormData.values, (!intentId && Object.keys(mutateFormData.initial).length === 0), mutateFormData.values.businessType)
                    }
                    handleClick={e => {
                        handleVerifyPiiAccount(e, {
                            type: GST,
                            piiData,
                            setIsUploading,
                            setIsPiiVerified,
                            intentId,
                        });
                    }}
                />
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.turnOverCategory}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.turnOverCategory.name}
                    />
                    <Field
                        name={currentMleFields.turnOverCategory.name}
                        type={currentMleFields.turnOverCategory.type}
                        id={currentMleFields.turnOverCategory.name}
                        component={FormElems.Select}
                        data={[...defaultOption, ...nameValueOptions(Object.keys(basicFormDataList?.turnOverData))]}
                        labelField="name"
                        valueField="value"
                        placeholder={currentMleFields.turnOverCategory.label}
                        onChange={handleChangeCategory}
                        disabled={
                            isViewMode || isApproved(checkerRemarks, currentMleFields.turnOverCategory.name, null, isEditMode)
                        }
                        infoElement={infoMsgs?.[currentMleFields.turnOverCategory.name]}
                    />
                </div>
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.companyId} // Fallback to currentMleFields if newMleFields not set
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.companyId.name}
                    />
                    <Field
                        name={currentMleFields.companyId.name} // Keep name same for Redux Form
                        type={ currentMleFields.companyId.type}
                        component={FormElems.Input}
                        placeholder={currentMleFields.companyId.label}
                        disabled={isViewMode || isApproved(checkerRemarks, currentMleFields.companyId.name, null, isEditMode)}
                        required={currentMleFields.companyId?.fieldValidations?.required} // Explicitly pass required
                    />
                </div>
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.turnoverAmount}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.turnoverAmount.name}
                    />
                    <Field
                        name={currentMleFields.turnoverAmount.name}
                        type={currentMleFields.turnoverAmount.type}
                        id={currentMleFields.turnoverAmount.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.turnoverAmount.label}
                        disabled={
                            isViewMode ||
                            !mutateFormData.values[currentMleFields.turnOverCategory.name] ||
                            isApproved(checkerRemarks, currentMleFields.turnoverAmount.name, null, isEditMode)
                        }
                        onChange={handleChangeturnOverAmount}
                    />
                </div>
                <div className="form-field">
                    <TitleComponent 
                        field={currentMleFields.email} 
                        checkerRemarks={checkerRemarks} 
                        isEditMode={isEditMode} 
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.email.name}
                    />
                    <Field
                        name={currentMleFields.email.name}
                        type={currentMleFields.email.type}
                        id={currentMleFields.email.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.email.label}
                        disabled={isViewMode || isApproved(checkerRemarks, currentMleFields.email.name, null, isEditMode)}
                    />
                </div>
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.websiteURLs}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.websiteURLs.name}
                    />
                    <Field
                        name={currentMleFields.websiteURLs.name}
                        type={currentMleFields.websiteURLs.type}
                        component={FormElems.Input}
                        placeholder={currentMleFields.websiteURLs.label}
                        disabled={
                            isViewMode || isApproved(checkerRemarks, currentMleFields.websiteURLs.name, null, isEditMode)
                        }
                        required={currentMleFields.websiteURLs?.fieldValidations?.required}
                    />
                </div>
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.telephoneNumbers}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.telephoneNumbers.name}
                    />
                    <Field
                        name={currentMleFields.telephoneNumbers.name}
                        type={currentMleFields.telephoneNumbers.type}
                        id={currentMleFields.telephoneNumbers.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.telephoneNumbers.label}
                        disabled={
                            isViewMode || isApproved(checkerRemarks, currentMleFields.telephoneNumbers.name, null, isEditMode)
                        }
                    />
                </div>
                <div className="form-field">
                    <TitleComponent
                        field={currentMleFields.mobileNumber}
                        checkerRemarks={checkerRemarks}
                        isEditMode={isEditMode}
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.mobileNumber.name}
                    />
                    <Field
                        name={currentMleFields.mobileNumber.name}
                        type={currentMleFields.mobileNumber.type}
                        id={currentMleFields.mobileNumber.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.mobileNumber.label}
                        maxLength={10}
                        infoElement="Please enter 10 digit phone number"
                        disabled={
                            isViewMode || isApproved(checkerRemarks, currentMleFields.mobileNumber.name, null, isEditMode)
                        }
                    />
                </div>
                <div className="form-field">
                    <TitleComponent 
                        field={currentMleFields.appLink} 
                        checkerRemarks={checkerRemarks} 
                        isEditMode={isEditMode} 
                        isReEditFlow={isReEditFlow}
                        infoMsgs={infoMsgs}
                        fieldName={currentMleFields.appLink.name}
                    />
                    <Field
                        name={currentMleFields.appLink.name}
                        type={currentMleFields.appLink.type}
                        id={currentMleFields.appLink.name}
                        component={FormElems.Input}
                        placeholder={currentMleFields.appLink.label}
                        disabled={isViewMode || isApproved(checkerRemarks, currentMleFields.appLink.name, null, isEditMode)}
                    />
                </div>
            </li>
        </ul>
    );
};

const mapStateToProps = ({merchantLegalEntityData}) => {
    return {
        merchantLegalEntityData
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        { 
            change
         },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MleInformation);